import { selectBox } from '../select_box.js';
import { accordion } from '../accordion.js';

const eventsInit = class {
  constructor() {
  /*==============================================
  page link
  ==============================================*/
    $('a[href^="#"]').click(function() {
      var speed = 600;
      var href = $(this).attr("href");
      var target = $(href == "#" || href == "" ? 'html' : href);
      var position = target.offset().top;
      $("html, body").animate({
        scrollTop: position
      }, speed, "swing");
      return false;
    });


  /*==============================================
  ハンバーガーメニュー
  ==============================================*/
    $('.navToggle').click(function() {
      $(this).toggleClass('active');

      if ($(this).hasClass('active')) {
        $('.globalMenuSp').addClass('active');
      } else {
        $('.globalMenuSp').removeClass('active');
      }
    });


  /*==============================================
  モーダル
  ==============================================*/
    $('.modal01-open').on('click', function() {
      $('.modal01').fadeIn();
      return false;
    });
    $('.modal02-open').on('click', function() {
      $('.modal02').fadeIn();
      return false;
    });
    $('.modal03-open').on('click', function() {
      $('.modal03').fadeIn();
      return false;
    });
    $('.modal04-open').on('click', function() {
      $('.modal04').fadeIn();
      return false;
    });
    $('.modal05-open').on('click', function() {
      $('.modal05').fadeIn();
      return false;
    });
    $('.modal06-open').on('click', function() {
      $('.modal06').fadeIn();
      return false;
    });
    $('.modal07-open').on('click', function() {
      $('.modal07').fadeIn();
      return false;
    });
    $('.js-modal-close').on('click', function() {
      $('.js-modal').fadeOut();
      return false;
    });

    // 文面テンプレート新規作成
    $('.modal-msg-tmp-open').on('click', function() {
      $('#scouts-template-form').prop('disabled', true);
      $('#scouts-template-form').removeClass('btn_01-create');
      $('#scouts-template-form').addClass('btn_01-disabled');
      $('.template-conetnt-area').val($('#scout_content').val())
      $('.modal-msg-tmp').fadeIn();
      return false;
    });

    $('.js-modal-msg-tmp-close').on('click', function() {
      $('.modal-msg-tmp').find('.template-name-input').val('');
      $('.modal-msg-tmp').find('.template-conetnt-area').val('');

      $('.modal-msg-tmp').fadeOut(function() {
      });
      return false;
    });

    // 文面テンプレート編集
    $(document).on('click', '.js-modal-show-edit-open', function() {
      var tmpId = $(this).parents('.temp-item').attr('rel')
      var elem = $(`[data-id=${tmpId}]`);

      $('.template-edit-name-input').val(elem.text())
      $('.template-edit-conetnt-area').val(elem.attr('data-content'))
      $('.template-edit-id').val(tmpId)

      $('#scouts-template-edit-form').prop('disabled', false);
      $('#scouts-template-edit-form').removeClass('btn_01-disabled');
      $('#scouts-template-edit-form').addClass('btn_01-create');
      $('.modal-msg-edit-tmp').fadeIn()
      return false;
    });

    $('.js-modal-msg-tmp-edit-close').on('click', function() {
      $('.modal-msg-edit-tmp').find('.template-edit-name-input').val('');
      $('.modal-msg-edit-tmp').find('.template-edit-conetnt-area').val('');

      $('.modal-msg-edit-tmp').fadeOut(function() {
      });
      return false;
    });

    // 文面テンプレート削除
    $(document).on('click', '.js-modal-show-delete-open', function() {

      var delId = $(this).parents('.temp-item').attr('rel')
      $('.delete-id').val(delId);

      $('.modal-msg-delete-confirm').fadeIn()
      return false;
    });

    $('.js-modal-msg-tmp-delete-close').on('click', function() {
      $('.modal-msg-delete-confirm').fadeOut(function() {
      });
      return false;
    });

    // テンプレート用のモーダル閉じる
    $('.js-modal-tmp-close').on('click', function() {
      $('.modal-msg-tmp').find('.template-name-input').val('');
      $('.modal-msg-tmp').find('.template-conetnt-area').val('');
      $('.modal-msg-edit-tmp').find('.template-edit-name-input').val('');
      $('.modal-msg-edit-tmp').find('.template-edit-conetnt-area').val('');
      $('.modal-msg-delete-confirm').find('.delete-id').val('')
    
      $('.js-tmp-modal').fadeOut()
      return false
    })

    // テンプレートフォーム（新規） 送信制御
    $('.template-name-input, .template-conetnt-area').on('keyup', function() {
      if($('.template-name-input').val() !== '' && $('.template-conetnt-area').val() !== ''){
          $('#scouts-template-form').prop('disabled', false);
          $('#scouts-template-form').addClass('btn_01-create');
          $('#scouts-template-form').removeClass('btn_01-disabled');
      }else {
          $('#scouts-template-form').prop('disabled', true);
          $('#scouts-template-form').addClass('btn_01-disabled');
          $('#scouts-template-form').removeClass('btn_01-create');

      }
    })

    // テンプレートフォーム（編集） 送信制御
    $('.template-edit-name-input,.template-edit-conetnt-area').on('keyup', function() {
      if($('.template-edit-name-input').val() !== '' && $('.template-edit-conetnt-area').val() !== ''){
          $('#scouts-template-edit-form').prop('disabled', false);
          $('#scouts-template-edit-form').addClass('btn_01-create');
          $('#scouts-template-edit-form').removeClass('btn_01-disabled');
      }else {
          $('#scouts-template-edit-form').prop('disabled', true);
          $('#scouts-template-edit-form').addClass('btn_01-disabled');
          $('#scouts-template-edit-form').removeClass('btn_01-create');

      }
    })


  /*==============================================
  select_01をセレクトするとselect_02にクラス名つける（VFE006）
  ==============================================*/
    $('.select_01 li').click(function() {
      $('.select_02').addClass('go');
    });
  /*==============================================
  メッセージのタブ
  ==============================================*/
    $('.messe').click(function() {
      $('.area').removeClass('open');
    });
  }
}


// ------------------------------------------------------------------
// CONTROLLER
// ------------------------------------------------------------------
$(window).on('load', function() {
  var events = new eventsInit();
  // セレクトボックス
  var selectBoxObj = new selectBox($('select'));
  // アコーディオン
  var accordionObj = new accordion();
});
